import {
    CANCEL_CART_ROSTER_ENTRY_FORM,
    SET_ROSTERS_COMPLETE,
    SET_EVENTS_FOR_ROSTER_CHECKOUT
} from './constants';

export const cancelCartRosterEntryForm = () => ({
    type: CANCEL_CART_ROSTER_ENTRY_FORM
});

export const setRostersComplete = payload => ({
    type: SET_ROSTERS_COMPLETE,
    payload: payload
});

export const setEventsForRosterCheckout = payload => ({
    type: SET_EVENTS_FOR_ROSTER_CHECKOUT,
    payload: payload
});



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/actionTypes.js